import {Directive, ElementRef, Input} from '@angular/core';
import $ from 'jquery';

@Directive({
    selector: '[scrollToTrackingLine]',
    standalone: false
})
export class ScrollToTrackingLineDirective {

    constructor(private el: ElementRef) {
    }

    @Input('scrollToTrackingLine')
    public set trackingLine(values: [string, string]) {
        if (values && values[0] && values[0] === values[1]) {
            const offset = $(this.el.nativeElement).offset();
            $('html, body').animate({
                scrollTop: offset.top - 150
            }, 400);
        }
    }
}
